export default __webpack_public_path__ + "static/media/apple-pay.56c67460.png";